import { useState } from "react";
import { faqList } from "@/mocks/gossip";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="scroll-mt-20 bg-[#F4EDE2]">
      <div className="mx-auto w-full max-w-6xl px-4 py-8 md:px-6 md:py-12">
        <div className="mx-auto max-w-3xl text-center">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-white px-3 py-1 text-xs font-medium text-emerald-800">
            <i className="ri-verified-badge-line"></i>吃瓜规则 FAQ
          </span>
          <h2 className="mt-3 text-xl font-extrabold text-stone-900 md:text-2xl">这些瓜是怎么被整理到一起的</h2>
          <p className="mx-auto mt-2 max-w-xl text-sm text-stone-600">
            汇总方式、口径与更新逻辑都在这里说清楚，读懂了吃起来更放心。
          </p>
        </div>

        <div className="mx-auto mt-6 flex max-w-3xl flex-col gap-3">
          {faqList.map((f, idx) => {
            const open = openIdx === idx;
            return (
              <div
                key={idx}
                className="overflow-hidden rounded-xl border border-stone-200/80 bg-white transition-colors"
              >
                <button
                  type="button"
                  onClick={() => setOpenIdx(open ? -1 : idx)}
                  className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
                >
                  <span className="flex items-center gap-3">
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-lg text-sm font-bold ${
                        open ? "bg-emerald-600 text-white" : "bg-emerald-100 text-emerald-800"
                      }`}
                    >
                      {idx + 1}
                    </span>
                    <span className="text-[15px] font-semibold text-stone-900">{f.q}</span>
                  </span>
                  <i className={`shrink-0 text-stone-500 ri-arrow-down-s-line text-xl transition-transform duration-200 ${open ? "rotate-180" : ""}`}></i>
                </button>
                {open && (
                  <div className="px-5 pb-5 pl-[60px]">
                    <p className="text-sm leading-relaxed text-stone-600">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}